import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Users, Award, LineChart, Calendar, ShieldCheck } from 'lucide-react';

const activities = [
  {
    icon: BookOpen,
    title: 'Curriculum Development',
    description: 'Supporting African universities in developing comprehensive climate finance programs.',
  },
  {
    icon: Users,
    title: 'Partnership Programs',
    description: 'Facilitating South-South-North collaborations with scholarship opportunities.',
  },
  {
    icon: Award,
    title: 'Skill Enhancement',
    description: 'Offering specialized short-term courses for professionals and practitioners.',
  },
  {
    icon: LineChart,
    title: 'Advisory Services',
    description: 'Providing expert guidance to private enterprises and NGOs.',
  },
  {
    icon: Calendar,
    title: 'Events & Conferences',
    description: 'Organizing key events focused on climate finance advancement.',
  },
  {
    icon: ShieldCheck,
    title: 'Quality Assurance',
    description: 'Ensuring high standards in all our training and development programs.',
  },
];

export default function Activities() {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Activities</h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Comprehensive programs and initiatives driving Africa's sustainable future
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {activities.map((activity, index) => (
            <motion.div
              key={activity.title}
              className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="flex items-center space-x-4">
                <div className="bg-gradient-to-br from-green-500 to-emerald-600 p-3 rounded-lg">
                  <activity.icon className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900">{activity.title}</h3>
              </div>
              <p className="mt-4 text-gray-600 leading-relaxed">{activity.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}